import React from 'react';

interface DashboardLoadingGateProps {
    initialDashboardReady: boolean;
    /** When true, render dashboard under the frosted init overlay so blur shows page content. */
    showContentUnderOverlay?: boolean;
    /** When true, render children so site-load error banner can display. */
    siteLoadFailed?: boolean;
    children: React.ReactNode;
}

export const DashboardLoadingGate: React.FC<DashboardLoadingGateProps> = ({
    initialDashboardReady,
    showContentUnderOverlay = false,
    siteLoadFailed = false,
    children,
}) => {
    if (!initialDashboardReady && !showContentUnderOverlay && !siteLoadFailed) {
        return null;
    }
    return <>{children}</>;
};
